module.exports = __webpack_public_path__ + "static/p2040036-4c2df24f97545e8f909beaabfa0d2f7f.jpg";